
import React from 'react';
import { Button } from '@/components/ui/button';

interface FormNavigationButtonsProps {
  isFirstStep: boolean;
  isLastStep: boolean;
  isSubmitting: boolean;
  handleBack: () => void;
  handleNext: () => void;
  handleCancel: () => void;
  validateStep: (step: number) => boolean;
  currentStep: number;
}

const FormNavigationButtons: React.FC<FormNavigationButtonsProps> = ({
  isFirstStep,
  isLastStep,
  isSubmitting,
  handleBack,
  handleNext,
  handleCancel,
  validateStep,
  currentStep
}) => {
  return (
    <div className="flex justify-between space-x-2 pt-4">
      {!isFirstStep && (
        <Button 
          type="button" 
          variant="outline" 
          onClick={handleBack}
          disabled={isSubmitting}
        >
          Back
        </Button>
      )}
      
      {!isLastStep ? (
        <Button 
          type="button" 
          onClick={handleNext}
          disabled={isSubmitting || !validateStep(currentStep)}
          className="ml-auto"
        >
          Next
        </Button>
      ) : (
        <div className="flex space-x-2 ml-auto">
          <Button 
            type="button" 
            variant="outline" 
            onClick={handleCancel}
            disabled={isSubmitting}
          >
            Cancel
          </Button>
          <Button type="submit" disabled={isSubmitting}>
            {isSubmitting ? 'Registering...' : 'Register Device'}
          </Button>
        </div>
      )}
    </div>
  );
};

export default FormNavigationButtons;
